export default __webpack_public_path__ + "static/media/photo--lg--justin.3c72e136.jpg";